import { Theme } from "@emotion/react";
import { SxProps } from "@mui/material";
import {
    Box,
} from "@mui/material";
import React, { ElementType, ReactNode, FormEvent } from "react";

interface BoxProps {
    component: ElementType;
    sx?: SxProps<Theme>;
    children?: ReactNode;
    src?: any;
    alt?: string;
    className?: string;
    onSubmit?: (event: FormEvent<HTMLFormElement>) => void;
}

const BoxComponent = (props: BoxProps) => {
    return <Box
        sx={props.sx}
        component={props.component as React.ElementType}
        src={props.src}
        alt={props.alt}
        className={props.className}
        onSubmit={props.onSubmit}
    >
        {props.children}
    </Box>
}

export default BoxComponent;